import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import TabPanelComponentEditable from './TabPanelEditable';
import TabPanelComponentReadOnly from './TabPanelReadOnly';

const TabsNodeView: React.FC = () => {
  const { node, view, getPos } = useReactNodeView();

  if (!view?.editable) {
    return <TabPanelComponentReadOnly {...node?.attrs} />;
  }

  return <TabPanelComponentEditable {...node?.attrs} />;
};

export default TabsNodeView;
